export default __webpack_public_path__ + "static/media/gallery_test(7).33f4968b.png";